export const getRBACMatrixUrl = (
  offset: number,
  rows: number,
  status?: string,
) => {
  const params = new URLSearchParams({
    offset: String(offset),
    rows: String(rows),
  });
  if (status) params.set("status", status);
  return `/admin/rbac?${params}`;
};

export const getRBACMatrixDetailsUrl = (id: string) => {
  return `/admin/roles/${id}`;
};

export const publishRoleUrl = (roleId: string) => {
  const params = new URLSearchParams({ roleId });
  return `/admin/roles/publish?${params}`;
};
